// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__81LsU","index":"styles_index__3u4VC"};